/* eslint-disable react/no-unknown-property */
import { useSelector, useDispatch } from 'react-redux';
import styles from './ToastContainer.module.scss';
import { Toast, ToastProps } from './Toast/Toast';
import { ColorPalettes } from '../Landing/LandingBlock/LandingBlock';
import { addToast, removeToast } from '../../redux/features/toastService';

interface ToastContainerProps {
  colorPalette?: ColorPalettes;
}

export const useToast = () => {
  const dispatch = useDispatch();

  const setToast = (newToast: Omit<ToastProps, 'id'>) => {
    const id = Math.random().toString();
    dispatch(addToast({ ...newToast, id }));
  };

  return { setToast };
};

export const ToastContainer = ({
  colorPalette = 'unknown',
}: ToastContainerProps) => {
  const dispatch = useDispatch();
  const toasts = useSelector((state: { toasts: ToastProps[] }) => state.toasts);

  const renderToasts = () => {
    return toasts?.map((toast) => (
      <Toast
        key={toast?.id}
        {...toast}
        onClose={() => {
          dispatch(removeToast({ id: toast.id }));
        }}
      />
    ));
  };

  return (
    <div className={styles.root} color-palette={colorPalette}>
      {renderToasts()}
    </div>
  );
};
